(function () {
  if (window.__lpInit) return;
  window.__lpInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---------- Reveal on scroll ---------- */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.setAttribute('data-in', 'true');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    function bindReveals(scope) {
      (scope || document).querySelectorAll('.lp__reveal:not([data-in])').forEach(function (el, i) {
        el.style.transitionDelay = Math.min(i % 6, 5) * 60 + 'ms';
        io.observe(el);
      });
    }
    bindReveals();

    /* Re-bind when the theme editor swaps a section in */
    document.addEventListener('shopify:section:load', function (e) { bindReveals(e.target); });

    /* ---------- Lightbox ---------- */
    var box = null;
    function openBox(src, alt) {
      if (!box) {
        box = document.createElement('div');
        box.className = 'lp-lightbox';
        box.innerHTML =
          '<button class="lp-lightbox__close" aria-label="\u0625\u063a\u0644\u0627\u0642">&times;</button>' +
          '<img class="lp-lightbox__img" alt="">';
        document.body.appendChild(box);
        box.addEventListener('click', function (e) {
          if (e.target === box || e.target.closest('.lp-lightbox__close')) closeBox();
        });
      }
      var img = box.querySelector('.lp-lightbox__img');
      img.src = src;
      img.alt = alt || '';
      box.setAttribute('data-open', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeBox() {
      if (!box) return;
      box.removeAttribute('data-open');
      document.documentElement.style.overflow = '';
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeBox(); });
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lp-zoom]');
      if (!trigger) return;
      e.preventDefault();
      openBox(trigger.getAttribute('data-lp-zoom'), trigger.getAttribute('data-lp-alt'));
    });
  });
})();
